import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Auth} from '@core/auth/auth';

@Component({
  selector: 'app-user-profile-menu',
  imports: [],
  templateUrl: './user-profile-menu.html',
  styleUrl: './user-profile-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileMenu {
  public auth = inject(Auth);
}
